import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../FaIcon';
import {accountLine, MAX_ACCOUNTS_LISTED} from './RenderWarningsNotice';

/**
 * El aviso de arriba del folio cuando hay cuentas del informe sin eventos de conversión elegidos
 * (card UvIR4eHe). Recupera el aviso que el Explorador daba al elegir una cuenta, pero sin su modal
 * que se abría solo («bastante intrusivo pero funcional», fede): acá se lee, y el modal lo abre
 * quien quiera resolverlo.
 *
 * Mismo marco que `RenderWarningsNotice` (`.inf-warning-notice`) a propósito: es la misma clase de
 * aviso —el informe se muestra, pero algo de lo que dice no es el dato real— y los dos pueden
 * convivir uno arriba del otro.
 *
 * Sólo en el editor de la agencia: el cliente del portal no puede elegir eventos, y los nombres de
 * las cuentas son de la agencia.
 */
export function EventsNotice({accounts, onConfigure}) {
    const {t, i18n} = useTranslation();
    if (!accounts || !accounts.length) return null;
    const count = accounts.length;
    return (
        <div className="inf-warning-notice inf-events-notice" role="status" data-testid="informes-events-notice">
            <FaIcon iconName="exclamation-triangle" className="inf-warning-notice__icon"/>
            <div className="inf-warning-notice__text">
                <strong className="inf-warning-notice__title">{t('informes.events.notice.title', {count})}</strong>
                <p className="inf-warning-notice__body">{t('informes.events.notice.body', {count})}</p>
                <ul className="inf-warning-notice__accounts">
                    {accounts.slice(0, MAX_ACCOUNTS_LISTED).map((account) => (
                        <li key={account.id}>{accountLine(account, t, i18n.language)}</li>
                    ))}
                    {count > MAX_ACCOUNTS_LISTED && (
                        <li className="inf-warning-notice__accounts-more">
                            {t('informes.warnings.accounts_more', {count: count - MAX_ACCOUNTS_LISTED})}
                        </li>
                    )}
                </ul>
            </div>
            <button type="button" className="btn -alt inf-warning-notice__cta" onClick={onConfigure}
                    data-testid="informes-events-configure">
                {t('informes.events.notice.cta')}
            </button>
        </div>
    );
}
